<template>
<v-dialog v-model="open" persistent max-width="768px" content-class="tw-rounded-3xl" scrollable>
    <v-form ref="form" v-model="valid" :disabled="form_disabled_state" lazy-validation enctype="multipart/form-data" @submit.prevent="update">
        <v-card class="tw-rounded-3xl tw-border-0 tw-shadow-md">
            <ModalHeader @close-modal="closeModal">{{$t('bz2.landing.social_media.title')}}</ModalHeader>
            <v-divider />
            <v-card-text class="tw-p-0" style="max-height: 700px">
                <v-responsive class="tw-py-0">
                    <v-container class="tw-bg-gray-50">
                        <v-row class="mb-5">
                            <v-col cols="12" class="mx-auto pa-5">
                                <v-card class="mx-auto tw-divide-y tw-divide-gray-200 tw-rounded-3xl tw-bg-transparent tw-shadow-none">
                                    <v-container class="pa-5">
                                        <div class="tw-grid tw-grid-cols-1">
                                            <div class="">
                                                <v-text-field v-model="mountedSection.data.title" :rules="[rules.required]" validate-on-blur outlined rounded :label="$t('app.title')" />
                                            </div>
                                        </div>
                                    </v-container>
                                    <v-container v-if="mountedSection.data.logos.length > 0" class="pa-5">
                                        <draggable v-model="mountedSection.data.logos" tag="div" handle=".handle" class="tw-space-y-4" ghost-class="ghost">
                                            <transition-group type="transition" :name="'flip-list'" tag="div" class="tw-space-y-4">
                                                <v-card
                                                    v-for="(logo, index) in mountedSection.data.logos"
                                                    :key="logo.uid"
                                                    outlined
                                                    class="tw-rounded-2xl tw-overflow-hidden"
                                                >
                                                    <div class="tw-flex tw-items-center tw-justify-between tw-bg-gray-100 tw-px-4 tw-py-2">
                                                        <div class="tw-flex tw-items-center tw-space-x-2">
                                                            <AppBtn color="transparent" icon-center="g-next" g-next="DragOrder" class="handle tw-cursor-move" fab x-small type="button" />
                                                            <span class="tw-text-sm tw-font-semibold tw-text-gray-600">
                                                                {{ $t('app.social_network') }} #{{ index + 1 }}
                                                            </span>
                                                        </div>
                                                        <AppBtn color="transparent-danger" icon-center="close" fab x-small type="button" @click="deleteItem(logo)" />
                                                    </div>
                                                    <v-container class="pa-4">
                                                        <v-text-field v-model="logo.link" outlined rounded dense label="Link" hide-details class="tw-mb-4" />
                                                        <v-btn-toggle v-model="logo.type" mandatory dense class="tw-mb-4">
                                                            <v-btn value="image" small>
                                                                {{ $t('app.upload_image') }}
                                                            </v-btn>
                                                            <v-btn value="icon" small>
                                                                {{ $t('app.use_icon') }}
                                                            </v-btn>
                                                        </v-btn-toggle>
                                                        <!-- Image mode -->
                                                        <div v-if="logo.type === 'image'" class="tw-flex tw-flex-col sm:tw-flex-row tw-gap-4">
                                                            <div class="tw-flex tw-gap-3 sm:tw-w-64">
                                                                <v-text-field
                                                                    v-model.number="logo.logo_width"
                                                                    type="number"
                                                                    min="1"
                                                                    outlined
                                                                    rounded
                                                                    dense
                                                                    hide-details
                                                                    :label="$t('app.image_width')"
                                                                />
                                                                <v-text-field
                                                                    v-model.number="logo.logo_height"
                                                                    type="number"
                                                                    min="1"
                                                                    outlined
                                                                    rounded
                                                                    dense
                                                                    hide-details
                                                                    :label="$t('app.image_height')"
                                                                />
                                                            </div>
                                                            <div class="tw-w-32">
                                                                <DropzoneOverlayPreview v-model="logo.logo_url" :width="logo.logo_width" :height="logo.logo_height" compact media-group="registries_social_media" />
                                                            </div>
                                                        </div>
                                                        <!-- Icon mode -->
                                                        <div v-else class="tw-grid tw-grid-cols-1 tw-gap-4 sm:tw-grid-cols-3 sm:tw-items-center">
                                                            <v-select
                                                                v-model="logo.icon"
                                                                :items="socialIconOptions"
                                                                outlined
                                                                rounded
                                                                dense
                                                                hide-details
                                                                :label="$t('app.social_icon')"
                                                            />
                                                            <div class="tw-flex tw-flex-col tw-items-start">
                                                                <span class="tw-text-xs tw-text-gray-500 tw-mb-1">{{ $t('app.icon_color') }}</span>
                                                                <ColorInput v-model="logo.icon_color" :is-rounded="false" />
                                                            </div>
                                                            <div class="tw-flex tw-items-center tw-space-x-3 tw-bg-gray-50 tw-rounded-xl tw-p-3">
                                                                <SocialIcon :name="logo.icon" :color="logo.icon_color" :background="logo.icon_background" />
                                                                <span class="tw-text-xs tw-text-gray-500">{{ $t('app.preview') }}</span>
                                                            </div>
                                                        </div>
                                                    </v-container>
                                                </v-card>
                                            </transition-group>
                                        </draggable>
                                    </v-container>
                                    <v-container>
                                        <div class="tw-flex tw-justify-end">
                                            <AppBtn type="button" icon="plus" color="white" @click="addLogo">
                                                {{ $t('app.add') }}
                                            </AppBtn>
                                        </div>
                                    </v-container>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-responsive>
            </v-card-text>
            <v-card-actions>
                <v-alert v-model="errorAlert" dismissible color="red" border="left" elevation="2" colored-border icon="error" transition="fade-transition">
                    {{ errorMsg }}
                </v-alert>
                <v-spacer />
                <AppBtn type="button" :disabled="form_loading" color="transparent" @click="closeModal">
                    {{ $t('app.cancel') }}
                </AppBtn>
                <AppBtn color="primary" :loading="form_loading" icon="check" type="submit">
                    {{ $t('app.save') }}
                </AppBtn>
            </v-card-actions>
        </v-card>
    </v-form>
</v-dialog>
</template>

<script>
import ModalHeader from '@/components/ModalHeader'
import {
    SocialMedia,
} from '@/models/RegistryLanding'
import draggable from 'vuedraggable'
import AppBtn from '../App/AppBtn.vue'
import DropzoneOverlayPreview from '../DropzoneOverlayPreview.vue'
import ColorInput from '@/components/FormInputs/ColorInput.vue'
import SocialIcon from '@/components/Icons/SocialIcon.vue'
import { socialIconOptions } from '@/enums/SocialIcons'
import {
    rules,
} from '@/utils/rules'
export default {
    name: 'BizzDomeUiRegistriesLandingsSocialMedia',
    components: {
        ModalHeader,
        draggable,
        AppBtn,
        DropzoneOverlayPreview,
        ColorInput,
        SocialIcon,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        section: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        valid: true,
        form_disabled_state: false,
        rules,
        isLoading: false,
        form_loading: false,
        mountedSection: {},
        errorAlert: false,
        errorMsg: '',
        socialIconOptions,
    }),
    computed: {
        open: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
    },
    created() {
        this.mountedSection = JSON.parse(JSON.stringify(this.section))
        this.mountedSection.data.logos = this.mountedSection.data.logos.map(
            (logo) => ({ ...SocialMedia(), ...logo }),
        )
    },
    methods: {
        update() {
            this.errorAlert = false
            if (!this.$refs.form.validate()) {
                return
            }

            this.$emit('updated-section', this.mountedSection)
            this.open = false
        },
        deleteItem(logo) {
            this.mountedSection.data.logos = this.mountedSection.data.logos.filter(
                (row) => row.uid != logo.uid,
            )
        },
        addLogo() {
            this.mountedSection.data.logos = [
                ...this.mountedSection.data.logos,
                SocialMedia(),
            ]
        },
        closeModal() {
            this.open = false
        },
    },
}
</script>
